import moment from "moment";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Modal from "../../components/Modal/Modal";
import { fetchPlansRequest } from "../../store/shopping/shopping.actions";
import { getUpgradePlan } from "../../store/shopping/shopping.selector";
import { fetchUserProfileRequest } from "../../store/user/user.actions";
import UserAPI from "../../store/user/user.api";
import { getUserProfile } from "../../store/user/user.selector";

const Plan = () => {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const dispatch = useDispatch();
    const [billingPeriod, setBillingPeriod] = useState("");

    const { userProfile, plans } = useSelector((state) => {
        return {
            plans: getUpgradePlan(state),
            userProfile: getUserProfile(state),
        };
    });

    useEffect(() => {
        if (userProfile.billingPeriod) {
            setBillingPeriod(userProfile.billingPeriod);
        }
    }, [userProfile]);

    useEffect(() => {
        dispatch(fetchPlansRequest());
        dispatch(fetchUserProfileRequest({}));
    }, []);

    const UpdateBilling = () => {
        Swal.fire({
            title: "Update billing?",
            text: "Your billing period will be changed to " + billingPeriod,
            icon: "question",
            showCancelButton: true,
            cancelButtonColor: "#d33",
            showConfirmButton: true,
            cancelButtonText: "Close",
            confirmButtonText: "Confirm",
            customClass: {
                cancelButton: "order-1 right-gap",
                confirmButton: "order-2",
                denyButton: "order-3",
            },
        }).then((x) => {
            if (x.isConfirmed) {
                UserAPI.ChangePeriod({}).then((x) => {
                    Swal.fire({
                        title: "Update billing",
                        text:
                            "Your billing period is changed to " +
                            billingPeriod,
                        icon: "success",
                        showCancelButton: true,
                        cancelButtonColor: "#d33",
                        showConfirmButton: false,
                        cancelButtonText: "Close",
                        customClass: {
                            cancelButton: "order-1 right-gap",
                            confirmButton: "order-2",
                            denyButton: "order-3",
                        },
                    }).then((x) => {
                        if (x.isDismissed) {
                            dispatch(fetchUserProfileRequest());
                        }
                    });
                });
            }
        });
    };

    if (!plans || !plans[0]) {
        return <p />;
    }

    return (
        <div>
            <div className="mb-[26px]">
                <h3 className="text-base font-bold text-ebony-color mb-1.5">
                    User Plan
                </h3>
                <span className="inline-block py-1.5 px-[30px] bg-[#FFF6EB] rounded-full text-orange-color font-bold text-sm uppercase mb-1.5">
                    {userProfile.role}
                </span>
                {userProfile.role === "Pro" ? (
                    <p className="text-sm font-medium text-black-60">
                        PRO offers cutting-edge features that enable you to
                        stand out and maximise the potential of your business
                    </p>
                ) : (
                    <p className="text-sm font-medium text-black-60 mt-2">
                        <button
                            onClick={() => navigate("/page/upgradePlan")}
                            className="py-2.5 px-5 bg-orange-color text-white text-sm font-bold capitalize rounded-lg whitespace-nowrap w-full sm:w-fit"
                        >
                            Upgrade Plan
                        </button>
                    </p>
                )}
            </div>

            {userProfile.role === "Pro" && (
                <div className="">
                    <h3 className="text-base font-bold text-ebony-color mb-3.5">
                        Your current plan
                    </h3>

                    <div className="flex flex-col sm:flex-row gap-6">
                        <div className="flex-1 p-4 rounded-10 border border-black-10 shadow-[0px_0px_16px_rgba(0, 0, 0, 0.03)]">
                            <div className=" text-sm text-black-60 mb-3.5">
                                <p className="text-base font-medium text-[#2B1C50]  mb-1">
                                    USD{" "}
                                    {userProfile.billingPeriod === "monthly"
                                        ? plans[0] &&
                                          plans[0].monthlyAmount + " / month"
                                        : plans[0] &&
                                          plans[0].yearlyAmount + " / year"}
                                </p>
                                <p className=" mb-1">
                                    Renew on{" "}
                                    {moment(userProfile.roleTimeExpired).format(
                                        "LL"
                                    )}
                                </p>
                                <p className="">
                                    Subscriber since{" "}
                                    {moment(userProfile.dateCreated).format(
                                        "LL"
                                    )}
                                </p>
                            </div>

                            <button
                                onClick={() => UpdateBilling()}
                                variant="contained"
                                color="primary"
                                disabled={
                                    userProfile.billingPeriod === billingPeriod
                                }
                                className="text-sm py-2.5 w-full rounded-lg border border-orange-color bg-orange-color font-bold text-center capitalize text-white"
                            >
                                Update Billing
                            </button>
                        </div>

                        <div className="flex-1 flex flex-col justify-between p-4 rounded-10 border border-black-10 shadow-[0px_0px_16px_rgba(0, 0, 0, 0.03)]">
                            <div className=" text-sm text-black-60 mb-3.5">
                                <p className="text-base font-medium text-[#2B1C50]  mb-1">
                                    Cancel your plan
                                </p>
                                <p className=" mb-1">
                                    Cancel your Ulalive PRO subscription
                                </p>
                            </div>

                            <button
                                onClick={() => {
                                    if (
                                        userProfile.subscriptionStatus === "" ||
                                        userProfile.subscriptionStatus ===
                                            "Active"
                                    ) {
                                        Swal.fire({
                                            title: "Stop my subscription",
                                            text: `Your PRO subscription will be stopped at the end of your billing period on  ${moment(
                                                userProfile.roleTimeExpired
                                            ).format(
                                                "LL"
                                            )}.You may change your mind anytime before this date.`,
                                            icon: "warning",
                                            showCancelButton: true,
                                            cancelButtonColor: "#d33",
                                            showConfirmButton: true,
                                            cancelButtonText: "Close",
                                            confirmButtonText: "Confirm",
                                            customClass: {
                                                cancelButton:
                                                    "order-1 right-gap",
                                                confirmButton: "order-2",
                                                denyButton: "order-3",
                                            },
                                        }).then((x) => {
                                            if (x.isConfirmed) {
                                                UserAPI.UnsubscribePRO({}).then(
                                                    (x) => {
                                                        dispatch(
                                                            fetchUserProfileRequest()
                                                        );
                                                    }
                                                );
                                            }
                                        });
                                    }
                                }}
                                className="text-sm py-2.5 w-full rounded-lg border border-black-10 bg-white font-medium text-center capitalize text-black-50"
                            >
                                Cancel my PRO plan
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <Modal show={showModal} onClose={() => setShowModal(false)}>
                <div className="p-5 pb-[30px] bg-white relative">
                    <div className="mb-3.5">
                        <h4 className="text-base font-bold text-ebony-color mb-0.5">
                            Monthly Billing
                        </h4>
                        <p className="text-sm font-medium text-black-60">
                            You can select either monthly or yearly billing
                        </p>
                    </div>

                    <div className="">
                        <form className="">
                            <label
                                htmlFor="billing-radio-1"
                                className="flex items-center mb-2.5 cursor-pointer"
                            >
                                <input
                                    id="billing-radio-1"
                                    type="radio"
                                    value=""
                                    name="default-radio"
                                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 sr-only peer"
                                />
                                <span className="w-4 h-4 rounded-full border border-[#D1D5DB] peer-checked:border-[5px] peer-checked:border-[#4F46E5]"></span>
                                <p className="ml-3 cursor-pointer text-sm font-medium text-ebony-color ">
                                    $29/ Month Monthly
                                </p>
                            </label>
                            <label
                                htmlFor="billing-radio-2"
                                className="flex items-start cursor-pointer"
                            >
                                <input
                                    checked
                                    id="billing-radio-2"
                                    type="radio"
                                    value=""
                                    name="default-radio"
                                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 sr-only peer"
                                />
                                <span className="w-4 h-4 rounded-full border border-[#D1D5DB] peer-checked:border-[5px] peer-checked:border-[#4F46E5]"></span>
                                <div className="ml-3">
                                    <div className=" flex items-center">
                                        <p className=" cursor-pointer text-sm font-medium text-ebony-color whitespace-nowrap w-full sm:w-fit ">
                                            $20/month Yearly
                                        </p>
                                        <p className="text-sm font-normal text-orange-color ml-1">
                                            Save 40% when you choose yearly
                                        </p>
                                    </div>
                                    <p className="text-extraSmall text-black-60">
                                        Total $240 for a year
                                    </p>
                                </div>
                            </label>
                        </form>

                        <div className="flex items-center gap-x-3 justify-center w-full mt-2.5 flex-col sm:flex-row gap-y-3">
                            <button
                                onClick={() => setShowModal(false)}
                                className="py-2.5 px-[22px] block rounded-lg text-white text-sm font-bold bg-orange-color whitespace-nowrap w-full capitalize"
                            >
                                save
                            </button>
                            <button
                                onClick={() => setShowModal(false)}
                                className="py-2.5 px-[22px] block rounded-lg text-black-50 text-sm font-medium bg-white border border-border-color whitespace-nowrap w-full capitalize"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default Plan;
